<template>
  <f7-page name="pzv-dyn-detail" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Kvalita podzemnej vody</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template>

      <div v-if="isObjektLoaded && !isError">

        <f7-list accordion-list no-margin-top>
          <f7-list-item accordion-item header="Údaje o objekte" :title="objektDetail.nazov_objektu + ` (` + objektDetail.cislo_objektu+`)`">
            <f7-accordion-content>
              <f7-list>
                <f7-list-item header="Typ" :title="objektDetail.typ_objektu.nazov"></f7-list-item>
                <f7-list-item header="Okres" :title="objektDetail.okres.nazov"></f7-list-item>
                <f7-list-item header="Okraj" :title="objektDetail.kraj.nazov"></f7-list-item>
                <f7-list-item header="Povodie" :title="objektDetail.povodie.nazov"></f7-list-item>
                <f7-list-item header="Útvar" :title="objektDetail.utvar"></f7-list-item>

                <f7-list-item v-if="objektDetail.monitoring !== null" header="Monitoring" :title="objektDetail.monitoring.nazov"></f7-list-item>
                <f7-list-item v-else header="Monitoring" title="-"></f7-list-item>

                <f7-list-item v-if="objektDetail.chvo !== null" header="CHVO" :title="objektDetail.chvo.nazov"></f7-list-item>
                <f7-list-item v-else header="CHVO" title="-"></f7-list-item>


              </f7-list>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>

        <f7-block-title>Údaje o meraniach</f7-block-title>
        <f7-list>
          <f7-list-input label="Dátum odberu" v-if="objektData.data.length > 0"
                         type="select"
                         :value="selectedMeranie"
                         @change="selectedMeranie = $event.target.value"
          >
            <option v-for="(meranie, index) in objektData.data" :key="index" :value="meranie.datum_odberu">{{ [meranie.datum_odberu, ['YYYY-MM-DD']] | moment("DD.MM.YYYY")  }}</option>
          </f7-list-input>
          <f7-list-input label="Skupiny ukazovateľov"
                         type="select"
                         :value="selectedSkupina"
                         @change="selectedSkupina = $event.target.value"
          >
            <option value :selected="selectedSkupina === ''">-- všetky --</option>
            <option v-for="(skupina, index) in skupinyUkazovatelov" :key="index" :value="skupina.id">{{ skupina.nazov }}</option>
          </f7-list-input>
        </f7-list>

        <f7-block-title>Ukazovatele</f7-block-title>
        <f7-list v-if="selectedMeranieData" class="pzv-dyn-list">
          <f7-list-item
            :class="(meranie.overlimit_current === true) ? 'tr-bg-red' : ''"
            v-for="(meranie, index) in selectedMeranieDataFiltered"
            :key="meranie.kod"
            :title="$options.filters.capitalize(getUkazovatelName(meranie.kod))"
            :after="meranie.hodnota + ` ` + getUkazovatelJednotka(meranie.kod)"
            :footer="getUkazovatelLimit(meranie.kod, true) + getOverLimitYearsExtra(meranie.overlimit_years)"
            >

          </f7-list-item>
        </f7-list>

        <!--table v-if="selectedMeranieData" style="margin-top: 5px" class="stripped">
          <tr><th style="width: 50%">Ukazovateľ</th><th style="width: 25%">Meraná hodnota</th><th style="width: 25%">Limitná hodnota<br><small>podľa Vyhlášky MZ SR č.247/2017 Z.z.</small></th></tr>
          <tr :class="(meranie.overlimit_current === true) ? 'tr-bg-red' : ''" v-for="(meranie, index) in selectedMeranieDataFiltered" :key="index">
            <td>{{ getUkazovatelName(meranie.kod) | capitalize }}</td>
            <td>{{ meranie.hodnota }} {{ getUkazovatelJednotka(meranie.kod) }}</td>
            <td>{{ getUkazovatelLimit(meranie.kod) }} <span v-html="getOverLimitYears(meranie.overlimit_years)"></span></td>
          </tr>
        </table-->

      </div>

    </template>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";


var progressDialog, loadingDialog;

export default {
  components: {

  },
  data: function () {
    return {
      ciselnikyData: {},
      isCiselnikyLoaded: false,
      objektData: {},
      isObjektLoaded: false,
      selectedMeranie: null,
      selectedSkupina: '',
      selectedMeranieData: {},
      isLoadingCter: 0,

      isError: false,
      errorMsg: null,
      isLoading: false,

      objektDetail: {},

      rok: null,
      cisloObjektu: null,
      parentSelectedSkupina: ''


    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    isLoadingCter(v, prev_v) {
      if (v <= 0) {
        if (loadingDialog !== null) {
          loadingDialog.close();
          loadingDialog = null;
        }
        this.isLoadingCter = 0;
      } else if (v === 1) {
        loadingDialog = this.$f7.dialog.preloader('Načítavam...');
      } else {
        // nerobime nic
      }
    },
    cisloObjektu(v) {
      if (v) {
        this.isObjektLoaded = false;
        this.getData(this.rok, this.cisloObjektu);
      } else {
        this.isObjektLoaded = false;
      }
    },
    objektData(v) {
      if (v) {

        this.selectedMeranie = this.latestDtMerania;

        this.$nextTick(() => {

          if (parseInt(this.parentSelectedSkupina) === -1) {
            this.selectedSkupina = "";
          } else {
            // vyhladaj ci taka skupin je vobec v zozname a ak ano, selectni
            if (this.skupinyUkazovatelov.find(item => parseInt(item.id) === parseInt(this.parentSelectedSkupina))) {
              this.selectedSkupina = this.parentSelectedSkupina;
            } else {
              // vyhladaj medanie, v ktorom sa takto skupina nachadza a selectni ho
              let zoznam_merani = v.data;
              if (zoznam_merani.length > 0) {
                zoznam_merani.forEach(item => { // pre kazde meranie z ojebktu ziskame skupiny
                  let c_skupiny = this.getSkupinyFromData(item.data);
                  // vyhladame ci v aktualnom merani sa nachadza pozadovana skupina
                  if (c_skupiny.find(item => parseInt(item.id) === parseInt(this.parentSelectedSkupina))) {
                    // ak ano, tak to meranie nastavime
                    this.selectedMeranie = item.datum_odberu;
                    this.$nextTick(() => {
                      this.selectedSkupina = this.parentSelectedSkupina;
                    });
                    return;
                  }
                });
              }

            }
          }

        });


      }
    },
    selectedMeranie(v) {
      const self = this;
      let tmp = self.objektData.data.find(item => item.datum_odberu === v);
      if (tmp) {
        if (tmp.datum_odberu === '0000-00-00') {
          this.isError = true;
          this.errorMsg = 'Údaje pre tento objekt nie sú správne!';
          self.$f7.dialog.alert(this.errorMsg, 'Nastala chyba spojenia');
        } else {
          this.isError = false;
          this.errorMsg = '';
          self.selectedMeranieData = tmp.data;

        }
      }
    }


  },
  computed: {
    selectedMeranieDataFiltered() {
      const i_selectedMeranieData = this.selectedMeranieData;
      let data = [];
      if (this.selectedSkupina !== "") {
        data = i_selectedMeranieData.filter(item => (item.ukazovatel) && parseInt(item.ukazovatel.skupina.id) === parseInt(this.selectedSkupina))
      } else {
        data = i_selectedMeranieData;
      }

      if (data.length > 0) {
        data.sort((a, b) => {
              let nazov_a = a.ukazovatel?.nazov ?? a.kod;
              let nazov_b = b.ukazovatel?.nazov ?? b.kod;
              let res = ((nazov_a > nazov_b) ? 1 : ((nazov_b > nazov_a) ? -1 : 0));
              // console.log(nazov_a, nazov_b, res)
              return res;
            }
        );
      }
      return data;

    },

    latestDtMerania() {
      const self = this;
      if (self.objektData) {
        let recs = self.objektData.data;
        recs.sort((a,b) => (self.$moment(a.datum_odberu).unix() < self.$moment(b.datum_odberu).unix()) ? 1 : ((self.$moment(b.datum_odberu).unix() < self.$moment(a.datum_odberu).unix()) ? -1 : 0));
        return recs[0].datum_odberu;
      }
      return null;
    },

    skupinyUkazovatelov() {
      const self = this;
      const selectedMeraniaData_tmp = self.selectedMeranieData;
      let skupiny = this.getSkupinyFromData(selectedMeraniaData_tmp);

      // zodarime podla nazvu
      if (skupiny.length > 0) {
        skupiny.sort((a, b) => (a.nazov > b.nazov) ? 1 : ((b.nazov > a.nazov) ? -1 : 0));
      }

      // overnie, ak je vybrana nejaka spupina, ale v novom vytvorenom zozname skupin uz takto skupina nie je, prepni na -- vsekty --
      if (this.selectedSkupina !== "") {
        if (!skupiny.find(item => parseInt(item.id) === parseInt(this.selectedSkupina))) {
          this.selectedSkupina = "";
        }

      }

      return skupiny;
    },

    // basics
    dostupneRoky() {
      const i_ciselnikyData = this.ciselnikyData;
      this.selectedYear = i_ciselnikyData.dostupne_roky[0];
      return i_ciselnikyData.dostupne_roky;
    },
    typyObjektov() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.typy_objektov;
    },
    povodia() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.povodia;
    },
    okresy() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.okresy;
    },
    chvo() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.chvo;
    },
    typy_objektov() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.typy_objektov;
    },
    ukazovatele() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.ukazovatele;
    },

  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      this.rok = this.$f7route.params.rok;
      if (this.$f7route.params.parentSelectedSkupina != '') {
        this.parentSelectedSkupina = this.$f7route.params.parentSelectedSkupina;
      }
      this.cisloObjektu = this.$f7route.params.cisloObjektu;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        this.getCiselniky();

      }


    },


    getCiselniky() {
      const self = this;

      let c = this.$ls.get('pzv_dyn_ciselniky');
      if (c) {
        this.ciselnikyData = c;
        this.isCiselnikyLoaded = true;
        return;
      }

      this.isLoadingCter++;

      Axios.get(SHMUconf.API_BASE_URL + 'pzvdyn/getciselniky', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.ciselnikyData = response.data;
              self.isCiselnikyLoaded = true;
              self.$ls.set('pzv_dyn_ciselniky', self.ciselnikyData, 7 * 24 * 60 * 60 * 1000); //  1 den
            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať číselníky ku kvalite podzemnej vody', 'Nastala chyba');
            }

            self.isLoadingCter--;

          }).catch((error) => {
        self.isLoadingCter--;
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });


    },
    getData(rok, cislo_objektu) {
      const self = this;

      this.isLoadingCter++;

      Axios.get(SHMUconf.API_BASE_URL + 'pzvdyn/getdata?rok=' + rok + '&cislo_objektu=' + cislo_objektu, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.objektData = response.data;
          self.objektDetail = self.objektData.objekt;
          self.isObjektLoaded = true;

        } else {
          self.$f7.dialog.alert('Nastala chyba pri načítavaní údajov!', 'Nastala chyba');
        }
        self.isLoadingCter--;

      }).catch((error) => {
        self.isLoadingCter--;
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },

    getUkazovatelName(name) {
      let item = this.ukazovatele.find(item => item.kod === name);
      if (item) {
        return item.nazov;
      }
      return name;
    },
    getUkazovatelLimitClass(name, value) {
      /* deprecated, uz sa pouziva informacia z parametre overlimit z web sluzby */
      let item = this.ukazovatele.find(item => item.kod === name);
      if (item) {
        let limit = item.limit;
        if (typeof value === "string")
        {
          value = value.replace('<', '');
          value = parseFloat(value);
        }

        if (limit !== null) {


          if (limit.indexOf('-') >= 0) { // je to rozsah
            let tmp = limit.split('-');
            let lo = parseFloat(tmp[0]);
            let hi = parseFloat(tmp[1]);
            if (value < lo) {
              return 'tr-bg-red';
            }
            if (value > hi) {
              return 'tr-bg-red';
            }

          } else { // je to len jedna hodnota
            limit = parseFloat(limit);
            if (value >= limit) {
              return 'tr-bg-red';
            }
          }
        }

      }
      return '';
    },
    getUkazovatelJednotka(name) {
      let item = this.ukazovatele.find(item => item.kod === name);
      if (item) {
        return item.jednotka;
      }
      return '';
    },
    getUkazovatelLimit(name, label) {
      let item = this.ukazovatele.find(item => item.kod === name);
      if (item && item.limit !== null) {
        let jednotka = '';
        if (item.jednotka) {
          jednotka = ' ' + item.jednotka;
        }
        let str = item.limit + jednotka;
        if (label === true) {
          str = 'Limitná hodnota: ' + str;
        }
        return str;
      }
      return '';
    },
    getOverLimitYears(arr) {
      if (arr && arr.length > 0) {
        return ' <small style="font-weight: normal">(' + arr.join(', ') + ')</small>';
      }
      return '';
    },

    getOverLimitYearsExtra(arr) {
      if (arr && arr.length > 0) {
        return ' - prekročené v ' + arr.join(', ');
      }
      return '';
    },
    getSkupinyFromData(data_arr) {
      let skupiny = [];
      if (data_arr.length > 0) {
        data_arr.forEach(function (v) {
          if (v.ukazovatel) {
            const tmp_skupina = v.ukazovatel.skupina;
            if (skupiny.find(item => parseInt(item.id) === parseInt(v.ukazovatel.skupina.id))) {

            } else {
              skupiny.push(tmp_skupina);
            }
          }
        });
      }
      return skupiny;
    },

    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 3 * 60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    onPageBeforeOut() {
      const self = this;
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.sheet.close();
    },
    onPageBeforeRemove() {
      const self = this;
      // console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.sheet) self.sheet.destroy();
    },

  }



}
</script>

<style lang="scss">

.sel {
  border: 1px solid #aaa;
  padding: 3px 5px !important;
  line-height: 1.33;
  height: 30px !important;
}


.pzv-dyn-list {
  .item-after {
    color: black;
    font-weight:bold;
  }

  .tr-bg-red {
      background-color: #c64e4e !important;
      color: white !important;
      font-weight: bold;

      .item-after, .item-footer  {
        color: white;
      }

  }


}

</style>
